import { MEDIA_WIDTH } from "../utils";
export var modalDefaultProps = {
  isScrollable: true,
  shouldCloseOnClickOutside: true
};
export var modalContentDefaultProps = {
  maxWidth: MEDIA_WIDTH
};
export var SCREEN_EDGE_GAP = 'S300';
export var PADDING_LARGE_VIEWPORT = 'S500';
export var PADDING_SMALL_VIEWPORT = 'S300';
export var PADDING_IN_HIGH_ZOOM_LEVEL = 'S200';
export var TITLE_SPACING = 'S500';
export var FOOTER_SPACING = 'S300'; // There should only ever be one modal on screen at once, so
// this ID will not appear on the page more than once

export var MODAL_TITLE_ID = 'stencil-modal-title';